import parseHTML from "../../lib/dom/funciones/parse_html";
const desplazadorDeGaleria = (galeria, direccion) => {
    const elemento = galeria.querySelector('li:nth-child(2)');
    return () => galeria.scroll({
        left: galeria.scrollLeft + direccion * galeria.offsetWidth / 2,
        behavior: 'smooth'
    });
};
const imagenes = () => {
    const contenedores = Array.from(document.querySelectorAll('.bloque--imagenes')), modal = document.querySelector('#galeria-modal');
    if (contenedores.length === 0 || modal === null) {
        return;
    }
    const galerias = contenedores.map(tabla => tabla.querySelector('ul'));
    const cerrarModal = modal.querySelector('.galeria__modal__cerrar button');
    const contenidoModal = modal.querySelector('.galeria__modal__contenido');
    if (!contenidoModal || !cerrarModal) {
        return;
    }
    cerrarModal.addEventListener('click', () => modal.close());
    modal.addEventListener('click', e => {
        if (e.target === modal) {
            modal.close();
        }
    });
    contenedores.forEach((hito, i) => {
        const anterior = parseHTML('<button class="imagenes__anterior" disabled>Anterior</button>'), siguiente = parseHTML('<button class="imagenes__siguiente">Siguiente</button>'), navegacion = parseHTML('<div class="imagenes__navegacion"></div>'), botones = galerias[i].querySelectorAll('button');
        navegacion.appendChild(anterior);
        navegacion.appendChild(siguiente);
        hito.appendChild(navegacion);
        anterior.addEventListener('click', desplazadorDeGaleria(galerias[i], -1));
        siguiente.addEventListener('click', desplazadorDeGaleria(galerias[i], 1));
        const actualizaBotones = () => {
            anterior.disabled = galerias[i].scrollLeft === 0;
            siguiente.disabled = Math.abs(galerias[i].scrollLeft + galerias[i].clientWidth - galerias[i].scrollWidth) < 2;
            navegacion.style.display = anterior.disabled && siguiente.disabled ? 'none' : 'flex';
        };
        galerias[i].addEventListener('scroll', actualizaBotones);
        addEventListener('resize', actualizaBotones);
        actualizaBotones();
        botones.forEach(boton => {
            boton.addEventListener('click', () => {
                contenidoModal.textContent = boton.dataset.texto || '';
                modal.showModal();
            });
        });
    });
    const ajustaScrolls = () => galerias.forEach((inner, i) => {
        if (inner.scrollWidth > inner.clientWidth) {
            contenedores[i].classList.add('is-scrollable');
        }
        else {
            contenedores[i].classList.remove('is-scrollable');
        }
    });
    addEventListener('resize', ajustaScrolls);
    addEventListener('load', ajustaScrolls);
    ajustaScrolls();
};
export default imagenes;
